import { css } from '@mui/material';

export const COARSE_POINTER_MEDIA_QUERY = '@media (pointer: coarse)';

export const MIN_TOUCH_TARGET_PX = 44;

/**
 * Grows the tap area of a small control on touch screens with an invisible, centred `::before`.
 * The visible box and the layout stay the same, and mouse/trackpad users see no change.
 * The element must be positioned (`relative` or `absolute`) and must not use `::before` itself.
 */
export const touchHitArea = (minSize = MIN_TOUCH_TARGET_PX) => css`
  ${COARSE_POINTER_MEDIA_QUERY} {
    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: max(100%, ${minSize}px);
      height: max(100%, ${minSize}px);
      transform: translate(-50%, -50%);
    }
  }
`;
